import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    chosenSupplier:'',
    tarbarIndex:0,
    tarbarShow:1,
    accessToken:'',
    searchShow: 0,
    searchFocus: 0,
    searchKeyword: 0
  },
  mutations: {
    setChosenSupplier: (state,data) =>{
        state.chosenSupplier = data
    },
    setTarbarIndex: (state,data) =>{
      state.tarbarIndex = data
    },
    setTarbarShow: (state,data) =>{
      state.tarbarShow = data
    },
    setAccessToken: (state,data) =>
    {
      state.accessToken = data
    },
    setSearchShow: (state,data) =>{
      state.searchShow = data
    },
    setSearchFocus: (state, data)=>{
      state.searchFocus = data
    },
    setSearchKeyword: (state, data)=>{
      state.searchKeyword = data
    },
  },
  actions: {

  }
})
